export const useThrottle = <T extends (...args: any[]) => void>(fn: T, delay: number): T => {
  let lastCall = 0;

  return ((...args: any[]) => {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }

    lastCall = now;
    fn(...args);
  }) as T;
};
